<div class="main">
    <button kendoButton [themeColor]="'primary'" style="width: 200px;"
        (click)="this.onDownload()">{{'Download PDF' | translate: 'Download PDF'}}</button>
    @if (this.pdfTooLarge) {
        <div class="pdf-too-large">
            {{'PDF is too large' | translate: 'PDF is too large for viewing, but can still download it!'}}
        </div>
    } @else { 
        <iframe #iframe class="iframe2">
        </iframe>

    }
    @if (this.jsBridgeService.isDev()) {
        <translation-editor />
    }
</div>